<template>
  <section class="about">
    <SectionCover :img="coverImage" v-scroll-nav="{ path: '/about' }" next-arrow>
      <div v-html="$t('about-title')" v-animate-in></div>
    </SectionCover>
    <Why />
    <Who />
    <Quote :quote="quote" v-if="quote" v-scroll-nav="{ path: '/about/quote' }" />
  </section>
</template>

<script>
import SectionCover from '@/components/common/SectionCover';
import Quote from '@/components/common/Quote';
import Who from './Who';
import Why from './Why';
import imageMixin from '@/plugins/image-mixin';
import section from '@/assets/data/about/section';

export default {
  name: 'about',
  components: {
    SectionCover,
    Quote,
    Who,
    Why
  },
  mixins: [imageMixin],
  data() {
    return {
      quote: section.quote,
      coverImage: this.getImageOrientation(section.cover)
    };
  }
};
</script>

<style lang="scss" scoped>
.about {
  /deep/ {
    .quote {
      background-color: $col-purple-light;
      .quote-image path {
        fill: $col-blue-light;
      }
      .quote-author {
        color: $col-blue-light;
      }
    }
    .section-cover .title em {
      color: $col-purple-light;
    }
  }
}
</style>
